module.exports = __webpack_public_path__ + "media/images/featured-products/dc-modeller-f0c3269ee1cddeaaf2df4400f02df698.svg";